import React from 'react'
import { data } from '../Constant/data';

const WhatAreLumiAds = () => {
    let whatAreLumiAds = data.whatAreLumiAds;
    return (
        <>
            <section className='bg_red what_lumi_ads' id={whatAreLumiAds?.id}>
                <div className="wrap">
                    <figure className='bg_img v_center left'>
                        <img className='icon' src={whatAreLumiAds?.image?.url} alt={whatAreLumiAds?.image?.alt} />
                    </figure>
                    <div className="container">
                        <div className="right">
                            <div className="title_wrapper mb">
                                <h2 className='mb text_xxl text_right'>{whatAreLumiAds?.title?.content} <span className='text_white'>{whatAreLumiAds?.title?.highlight}</span></h2>
                                <p className='text_md text_right  '>{whatAreLumiAds?.sub_title}</p>
                            </div>
                            <p className='lh justify'>{whatAreLumiAds?.description}</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhatAreLumiAds